import { useCurrentUser } from 'features/users/hooks/userQueryHooks'
import { WorkflowPayload } from '../types'

function useIsEditorMode(workflow: WorkflowPayload | null) {
  const currentUserId = useCurrentUser()?.user_id
  const userId = workflow?.userId

  return currentUserId === userId
}

export default useIsEditorMode
